import { useEffect, useState } from 'react';

import { useDocumentScroll } from 'src/hooks/useDocumentScroll';
import { FILTER_MENU_SMALL_TRANSITION_DURATION } from '../../styles/FilterMenu.styles';

export const useStickyNav = (nav: HTMLDivElement | null) => {
  const [isVisible, setVisible] = useState(true);
  const [isSticky, setSticky] = useState(false);
  const { scrollTop, previousScrollTop } = useDocumentScroll();

  useEffect(() => {
    // Wait until the element has been instantiated before starting computations
    if (nav === null || !nav.offsetHeight) {
      return;
    }

    const { y } = nav.getBoundingClientRect() || { y: 0 };

    const isScrollingDown = previousScrollTop < scrollTop;
    const isScrollingUp = previousScrollTop > scrollTop;

    // Scrolling down and goes off screen - transition up (currently not sticky)
    if (isScrollingDown && !isSticky && y < 0) {
      setVisible(false);
    }

    // Scrolling down and is sticky
    if (isScrollingDown && isSticky && y <= 0) {
      setVisible(false);
      // Wait until the transition has finished (add 100ms buffer to avoid race condition) before removing sticky
      window.setTimeout(() => setSticky(false), FILTER_MENU_SMALL_TRANSITION_DURATION + 100);
    }

    // (If it's scrolling up and isn't already sticky, make it sticky
    // then bring it into view once the sticky css has been applied)
    if (isScrollingUp && !isSticky) {
      setSticky(true);
      setVisible(true);
    }
  }, [scrollTop, previousScrollTop, nav, isSticky]);

  return {
    isVisible,
    isSticky,
  };
};
